export default __webpack_public_path__ + "static/media/vityaz-sn.6a462793.svg";